export default "__VITE_ASSET__2a552b57__"